import React from "react";

export default class SuccessBtnDumpsters extends React.Component  
{
    
    render()
    {
        return (
            <div class="block services successtories mb-5">               
                <div className="card">   
                    <h3>Success Stories</h3> 
                    <div>
                        <div className="text">"My business has doubled since I teamed up with Hometown."</div>
                        <div className="author"><span>{'>>'}</span>Daniel Aunchman, Bay Area Debris Box</div>
                    </div>
                    <a className="btn btn-primary" href="/pro/guide/tags/success-stories">See Success Stories</a>                          
                </div>
            </div>
        )
    }
};